import { isValidPhoneNumber } from 'libphonenumber-js/mobile';

export const isPhoneValid = (phone) => {
  return isValidPhoneNumber(phone, 'SE');
};
